import { Box, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useTabNavLocation } from "~/hooks/useTabNavLocation";

import ClientConfigurations from "./ClientConfigurations";
import { FcConfigList } from "./FcConfigList";
import { LaunchDarklyFlags } from "./LaunchDarklyFlags";

const Configurations = () => {
  const { t } = useTranslation();

  const validTabs = [
    "fc-config",
    "launch-darkly-flags",
    "client-configurations"
  ];

  const { tabIndex, handleTabIndexChange } = useTabNavLocation({
    defaultTab: "client-configurations",
    validTabs,
    key: "configurations-tab"
  });
  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={(_event, newValue) => {
          handleTabIndexChange(newValue as string);
        }}
        sx={{
          ml: 2
        }}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab
          label={`${t("client configuration")}`}
          value="client-configurations"
        />
        <Tab label={`${t("fc configuration")}`} value="fc-config" />
        <Tab label={"Launch Darkly flags"} value="launch-darkly-flags" />
      </Tabs>

      <Box
        id="tab-content"
        sx={{
          height: `calc(100% - 48px)`,
          overflowY: "scroll",
          "&::-webkit-scrollbar": {
            display: "none"
          },
          scrollbarWidth: "none",
          msOverflowStyle: "none"
        }}
      >
        {tabIndex === "client-configurations" && <ClientConfigurations />}
        {tabIndex === "fc-config" && <FcConfigList />}
        {tabIndex === "launch-darkly-flags" && <LaunchDarklyFlags />}
      </Box>
    </>
  );
};

export default Configurations;
